var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Dashboard, Property 2=Inactive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11C7.44772 11 7 11.4477 7 12V14C7 14.5523 7.44772 15 8 15H42C42.5523 15 43 14.5523 43 14V12C43 11.4477 42.5523 11 42 11H8ZM8 19C7.44772 19 7 19.4477 7 20V22C7 22.5523 7.44772 23 8 23H42C42.5523 23 43 22.5523 43 22V20C43 19.4477 42.5523 19 42 19H8ZM7 28C7 27.4477 7.44772 27 8 27H42C42.5523 27 43 27.4477 43 28V30C43 30.5523 42.5523 31 42 31H8C7.44772 31 7 30.5523 7 30V28ZM8 35C7.44772 35 7 35.4477 7 36V38C7 38.5523 7.44772 39 8 39H42C42.5523 39 43 38.5523 43 38V36C43 35.4477 42.5523 35 42 35H8Z",
    fill: "#E0E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11C7.44772 11 7 11.4477 7 12V14C7 14.5523 7.44772 15 8 15H27V11H8ZM8 19C7.44772 19 7 19.4477 7 20V22C7 22.5523 7.44772 23 8 23H39V19H8ZM7 28C7 27.4477 7.44772 27 8 27H19V31H8C7.44772 31 7 30.5523 7 30V28ZM8 35C7.44772 35 7 35.4477 7 36V38C7 38.5523 7.44771 39 8 39H35V35H8Z",
    fill: "#C3CBD3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.6776e923eb7cebd29a6ad9b3a67b5232.svg";
export { ForwardRef as ReactComponent };